import api from "../../api/axios";
import { setTotalCollected } from "../stages/stageSlice";
import { 
    allRecords,
  recordPaymentStart, 
  recordPaymentSuccess, 
  recordPaymentFailure,
  updatePayment,
  removePayment
} from "./paymentSlice";
import Swal from "sweetalert2";
import { toast } from "react-hot-toast";


export const stagePaymentCollection = async (dispatch, paymentData, stageId, projectId) => {
    dispatch(recordPaymentStart());

    try {
        // paymentData now includes payment_status and stage_amount from the frontend
        const response = await api.post("/payments/record", {
            ...paymentData,
            stageId,
            projectId
        });

        if (response.data) {
            dispatch(recordPaymentSuccess(response.data));
            return true;
        }
    } catch (error) {
        const message = error.response?.data?.message || "Failed to record payment";
        dispatch(recordPaymentFailure(message));
        return false;
    }
};

export const updateStagePaymentRecord = async (dispatch, stageId, payload) => {
    dispatch(recordPaymentStart());
    try {
        const response = await api.patch(`/payments/stage/${stageId}`, payload);
        if (response.data && response.data.success) {
            // Reload all payments so report log is in sync
            const allRes = await api.get("/payments/all");
            if (allRes.data) {
                dispatch(allRecords(allRes.data));
            }
            toast.success("Payment record updated successfully");
            return true;
        }
        toast.error("Unexpected response from server.");
        return false;
    } catch (error) {
        const message = error.response?.data?.message || "Failed to update payment record";
        dispatch(recordPaymentFailure(message));
        toast.error(message);
        return false;
    }
};

export const deletePaymentRecord = async (dispatch, paymentId) => {
    dispatch(recordPaymentStart());
    try {
        await api.delete(`/payments/delete/${paymentId}`);
        dispatch(removePayment(paymentId));
        // Reload all payments so report log is in sync
        const allRes = await api.get("/payments/all");
        if (allRes.data) {
            dispatch(allRecords(allRes.data));
        }
        toast.success("Payment deleted successfully");
        return true;
    } catch (error) {
        const message = error.response?.data?.message || "Failed to delete payment";
        dispatch(recordPaymentFailure(message));
        toast.error(message);
        return false;
    }
};

export const fetchPaymentsByStage = async (stageId) => {
    try {
        const response = await api.get(`/payments/by-stage/${stageId}`);
        return response.data?.payments || [];
    } catch (error) {
        return [];
    }
};

export const updateIndividualPayment = async (dispatch, paymentId, payload) => {
    try {
        const response = await api.patch(`/payments/update/${paymentId}`, payload);
        if (response.data?.success) {
            // Reload all payments to keep report log in sync
            const allRes = await api.get("/payments/all");
            if (allRes.data) dispatch(allRecords(allRes.data));
            toast.success("Payment updated successfully");
            return true;
        }
        toast.error("Unexpected response from server.");
        return false;
    } catch (error) {
        const message = error.response?.data?.message || "Failed to update payment";
        toast.error(message);
        return false;
    }
};

export const fetchAllPayments = async (dispatch) => {
    dispatch(recordPaymentStart()); // Reuse the start action for loading state
    try {
        const response = await api.get("/payments/all"); // Ensure this matches your backend route

        if (response.data) {
            dispatch(allRecords(response.data));
            return true;
        }
    } catch (error) {
        const message = error.response?.data?.message || "Failed to fetch payment records";
        dispatch(recordPaymentFailure(message));
        return false;
    }
};